import { binary_search_iterative_ref } from "../utils/binary_search_iterative_ref";
import { QXMLObject } from "./QXMLObject";

export class QFieldValueLib extends QXMLObject {
  constructor() {
    super();
    this.fFieldID = null;
    this.fValueList = null;
  }

  InitFieldValueLib(fieldID) {
    this.fFieldID = fieldID;
    this.fValueList = new Array();
    this.SetXMLElementName("fieldvallib");
  }

  ValueCount() {
    return this.fValueList.length;
  }

  GetFieldID() {
    return this.fFieldID;
  }

  CullValueList() {
    var n = this.fValueList.length;
    if (n < 2) return;

    this.fValueList.sort();
    var newList = new Array();
    var curValue = this.fValueList[0];
    newList.push(curValue);
    var maxValSize = curValue.toString().length;

    for (var i = 1; i < n; i++) {
      var nextValue = this.fValueList[i];
      if (nextValue != curValue) {
        maxValSize = Math.max(nextValue.toString().length, maxValSize);
        newList.push(nextValue);
        curValue = nextValue;
      }
    }

    this.fValueList = newList;
    return maxValSize;
  }

  AddRefValue(fieldValue) {
    fieldValue = fieldValue.toString();
    this.fValueList.push(fieldValue);
  }

  GetRefValue(fieldValue) {
    var index = binary_search_iterative_ref(this.fValueList, fieldValue);
    //    var index = this.fValueList.indexOf(fieldValue);
    return index;
  }

  LookupRef(refValue) {
    var index = parseInt(refValue);
    var v = this.fValueList[index];
    return v;
  }

  OutputToJSON(stream) {
    var fieldValueLib = {};
    fieldValueLib["ID"] = this.fFieldID;

    var f = this.fValueList;
    var n = f.length;
    fieldValueLib["valList"] = this.fValueList; //Will this work?
    return fieldValueLib;
  }

  LoadFromJSON(json) {
    this.fFieldID = json["ID"];
    this.fValueList = json["valList"];
  }

  OutputSubElements(stream) {
    this.OutputSimpleElement("fieldID", this.fFieldID, stream);

    var f = this.fValueList;
    var n = f.length;
    for (var i = 0; i < n; i++) {
      var aValue = f[i];
      this.OutputSimpleElement("v", aValue, stream);
      //this.OutputVElement(aValue, stream);
    }
  }

  LoadSubElements(objTree) {
    this.fFieldID = objTree.GetValueForChild("fieldID", false);
    var tValues = objTree.GetChildOfTypeList("v");

    var n = tValues.length;

    this.fValueList = [];
    for (var i = 0; i < n; i++) {
      var info = tValues[i];
      var theValue = info.GetValue();
      theValue = theValue.toString();
      //else
      //	console.log("Hello!");

      this.fValueList.push(theValue);
    }
  }
}
